module.exports = __webpack_public_path__ + "static/living-with-a-seal-f618fed494fd9515306bf5b0ccb27306.jpg";